(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Position active menu triangle
  function positionActiveTriangle() {
    const activeSpan = document.querySelector('span.header__active-menu-item');
    const activeMenuItem = activeSpan ? activeSpan.closest('a') : null;
    const header = document.querySelector('.header');
    
    if (activeMenuItem && header) {
      const existingTriangle = document.querySelector('.active-menu-triangle');
      if (existingTriangle) {
        existingTriangle.remove();
      }
      
      const triangle = document.createElement('div');
      triangle.className = 'active-menu-triangle';
      
      const menuRect = activeMenuItem.getBoundingClientRect();
      const headerRect = header.getBoundingClientRect();
      const triangleLeft = menuRect.left - headerRect.left + (menuRect.width / 2);
      
      triangle.style.left = triangleLeft + 'px';
      header.appendChild(triangle);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', positionActiveTriangle);
  } else {
    positionActiveTriangle();
  }

  window.addEventListener('resize', positionActiveTriangle);

  // Customer dropdown: close on scroll, reposition on open
  (function() {
    function getHeaderBottom() {
      const header = document.querySelector('.section-header');
      if (!header) return 80;
      return header.getBoundingClientRect().bottom;
    }

    function repositionDropdown() {
      const menu = document.querySelector('.customer-dropdown-menu');
      if (!menu) return;
      // Use the live bounding rect of the section-header so it tracks
      // the sticky header's actual position after transforms/animations
      menu.style.top = getHeaderBottom() + 'px';
    }

    function closeDropdown() {
      const details = document.querySelector('.customer-dropdown');
      if (details && details.open) {
        details.removeAttribute('open');
      }
    }

    // Close dropdown when user starts scrolling
    window.addEventListener('scroll', closeDropdown, { passive: true });

    // Reposition whenever the dropdown is opened
    // 'toggle' fires on <details> open/close in capture phase
    document.addEventListener('toggle', function(e) {
      if (e.target && e.target.classList && e.target.classList.contains('customer-dropdown')) {
        if (e.target.open) {
          // Use rAF so the browser has painted the open state before we measure
          requestAnimationFrame(repositionDropdown);
        }
      }
    }, true);

    // Also reposition on resize in case header height changes
    window.addEventListener('resize', function() {
      const details = document.querySelector('.customer-dropdown');
      if (details && details.open) {
        repositionDropdown();
      }
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
